/* eslint-disable import/no-unresolved */
import AuditLogsColumnConfig from 'views/Rules/common/AuditLogsColumnConfig';
import FFIEC031AduitLog from '../components/FFIEC031AduitLog';

const FFIEC031AduitLogs = ({ data }) => {
    const ffiec031Columns = AuditLogsColumnConfig;

    return (
        <FFIEC031AduitLog
            data={data}
            columns={ffiec031Columns}
        />
    );
};

export default FFIEC031AduitLogs;
